import Input, { type OTPInputProps } from "./Input";
import Root, { type OTPRootProps } from "./Root";
import Separator from "./Separator";

export const OTP = {
  Root,
  Input,
  Separator,
};

export const OTPRoot = Root;
export const OTPInput = Input;
export const OTPSeparator = Separator;

export type { OTPInputProps, OTPRootProps };
